import * as z from 'zod';

export const ServiceRequestUpdateEmailSchema = z.object({
  subject: z.string().trim().min(1, { message: 'Please enter valid subject' }),
  body: z.string().trim().min(1, { message: 'Please enter a valid body' }),
});

export type ServiceRequestUpdateEmailSchemaFields = z.infer<
  typeof ServiceRequestUpdateEmailSchema
>;
